import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Download, FileText, ChevronRight } from 'lucide-react';
import './Certification.scss';
import Breadcrumb from '../../components/common/Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';

const Certification = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 정보를 가져옴

  // 경로 일치 여부를 확인하는 함수
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const SERVER_URL = '';

  useEffect(() => {
    const fetchCerts = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/user/boards?board_type=certificate`);
        setCerts(res.data || []);
      } catch (err) {
        console.error('인증서 데이터 로드 실패:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCerts();
  }, []);

  const getFileName = (item) => {
    if (item.file_origin) return item.file_origin;
    if (item.file_original_name) return item.file_original_name;
    if (item.file_url) return item.file_url.split('/').pop();
    return '첨부파일 없음';
  };

  return (
    <div className="sub-page cert-page">
      <section className="sub-visual certification">
        <div className="container">
          <span className="sub-title">CERTIFICATION</span>
          <h1>인증서 및 성적서</h1>
          <p>베스트트레이딩은 검증된 품질과 기술력을 바탕으로 신뢰를 쌓아갑니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/community/notice')} onClick={() => navigate('/community/notice')}>
              공지사항
            </button>
            <button className={isActive('/community/orders')} onClick={() => navigate('/community/orders')}>
              발주관리(준비중)
            </button>
            <button className={isActive('/community/cert')} onClick={() => navigate('/community/cert')}>
              인증서 및 성적서
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        {loading ? (
          <div className="loading-state">데이터를 불러오는 중입니다...</div>
        ) : (
          <div className="cert-grid">
            {certs.length > 0 ? (
              certs.map((item) => (
                <article key={item.id} className="cert-item">
                  <div className="cert-card">
                    {/* 이미지 영역 */}
                    <div className="cert-img-box">
                      {item.image_url ? (
                        <img src={`${SERVER_URL}${item.image_url}`} alt={item.title} />
                      ) : (
                        <div className="img-placeholder">NO IMAGE</div>
                      )}
                    </div>

                    {/* 정보 영역 */}
                    <div className="cert-info">
                      <span className="category-tag">인증서</span>
                      <h4>{item.title}</h4>
                      <p>품질 및 기술 신뢰성을 증빙하는 공식 문서</p>
                    </div>

                    {/* 다운로드 버튼 */}
                    {item.file_url ? (
                      <a
                        href={`${SERVER_URL}${item.file_url}`}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cert-download-btn"
                      >
                        <div className="file-info">
                          <FileText size={16} />
                          <span className="file-name">{getFileName(item)}</span>
                        </div>
                        <Download size={18} className="dl-icon" />
                      </a>
                    ) : (
                      <div className="cert-download-btn disabled">
                        <div className="file-info">
                          <FileText size={16} />
                          <span className="file-name">등록된 파일이 없습니다.</span>
                        </div>
                      </div>
                    )}
                  </div>
                </article>
              ))
            ) : (
              <div className="no-data">등록된 인증서가 없습니다.</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Certification;
